import { render, staticRenderFns } from "./fifth.vue?vue&type=template&id=74ba242a&scoped=true&"
import script from "./fifth.vue?vue&type=script&lang=js&"
export * from "./fifth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ba242a",
  null
  
)

export default component.exports